import React from 'react';
import { Box, Typography, Alert, AlertTitle, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import MyLoginButton from './MyLoginButton';
import paths from '../../routes/paths';

const ErrorContainer = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(4),
  borderRadius: theme.spacing(1),
  boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
  maxWidth: '600px',
  margin: '0 auto',
}));


const MyLoginErrorHandler = ({ error, onRetry }) => {
  const getErrorGuidance = (errorMsg) => {
    if (!errorMsg) return 'An unknown error occurred during authentication.';
    
    if (errorMsg.includes('code')) {
      return 'The authorization code from MyLogin was invalid or expired. Please try again.';
    }
    
    if (errorMsg.includes('state')) {
      return 'The authentication state was invalid. This could be a security issue or your session may have expired.';
    }
    
    if (errorMsg.includes('tokens')) {
      return 'There was a problem exchanging your authentication code for access tokens.';
    }
    
    if (errorMsg.includes('user')) {
      return 'There was a problem retrieving your user information from MyLogin.';
    }
    
    return errorMsg;
  };
  
  return (
    <ErrorContainer>
      <Alert severity="error" sx={{ mb: 3 }}>
        <AlertTitle>Authentication Error</AlertTitle>
        {getErrorGuidance(error)}
      </Alert>
      
      <Box sx={{ mt: 3 }}>
        <Typography variant="body1" gutterBottom>
          Please try logging in again. If the problem persists, contact support.
        </Typography>
        
        <Box sx={{ mt: 3 }}>
          <MyLoginButton 
            redirectAfterLogin={paths.pupilSurveys}
            label="Try Again" 
            size="medium"
            onClick={onRetry}
          />
        </Box>
      </Box>
    </ErrorContainer>
  );
};

export default MyLoginErrorHandler;
